import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { MsgService } from 'src/app/component/common-components/msg/service/msg.service';
import { MsgModel } from './model/msg.model';

@Component({
  selector: 'app-msg',
  templateUrl: './msg.component.html',
  styleUrls: ['./msg.component.scss'],
})
export class MsgComponent implements OnDestroy {
  @Input() msg: MsgModel = new MsgModel();
  //msgSub: Subscription;

  constructor(protected msgService: MsgService) {
    // this.msgSub = this.msgService.messages$.subscribe((message) => {
    //   this.msg = message;
    // });
  }

  ngOnDestroy(): void {
    //this.msgSub.unsubscribe();
  }
}
